import axios from "axios";
import {  GetAllValutazioniFiltersDTO, GetAllValutazioniResponseData } from "./dto";
import { MonitoringValutazioniService } from "./service";
import { keycloak } from "../../../../lib/keycloak";

export class MonitoringValutazioniImpl implements MonitoringValutazioniService {

    public GetAllValutazioni(filters: GetAllValutazioniFiltersDTO): Promise<GetAllValutazioniResponseData[]> {
        return axios.get("/api/monitoring/starting-phase", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                sort: filters.sort,
                order: filters.order,
                valType: filters.valType ? filters.valType : '',
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }
}